import { DiscountProduct } from '@/entities/catalog-discount/schema/discount-product.schema'

import { DISCOUNT_ORDER_SOURCE } from '@/shared/lib/const/order-source'
import { PRODUCT_ID_URL_PREFIX } from '@/shared/lib/utils/constants/const'

export const getDiscountProductIdFromElementPath = (elementPath: string): string =>
	elementPath.replace(PRODUCT_ID_URL_PREFIX, ``)

export const getDiscountProductPageUrl = (id: number | string): string =>
	`/discount/products/${PRODUCT_ID_URL_PREFIX}${encodeURIComponent(String(id))}/`

export const getDiscountOrderUrl = (item: Pick<DiscountProduct, 'ID'>): string => {
	const params = new URLSearchParams({
		source: DISCOUNT_ORDER_SOURCE
	})

	return `/order/${item.ID}?${params.toString()}`
}
